import { GeneralModel, StatisticsModel } from '../../models';

export interface IState {
  newBadges: StatisticsModel.ITodayWidgetStatistics;
  grossRevenue: StatisticsModel.ITodayWidgetStatistics;
  workersActivity: StatisticsModel.ITodayWidgetStatistics;
  projectStatistics: StatisticsModel.IProjectStatistics;
  clientStatistics: StatisticsModel.IResourceStatistics;
  inventoryStatistics: StatisticsModel.IInventoryStatistics;
  workerStatistics: StatisticsModel.IWorkerStatistics;
  invoiceStatistics: StatisticsModel.IInvoiceStatistics;
  locationStatistics: StatisticsModel.ILocationStatistics;
  acsProjectStatistics: StatisticsModel.IAcsSummaryStatistics;
  bpsProjectStatistics: StatisticsModel.IDeviceStatistics;
  projectTopTenStatistics: StatisticsModel.IProjectTopTenStatistics[];
  clientTopTenStatistics: StatisticsModel.IClientTopTenStatistics[];
  grossRevenueWidgetStatistics: StatisticsModel.ILineWidgetStatistics;
  linePieStatisticsMap: GeneralModel.IEntityMap<StatisticsModel.ILinePieWidgetStatistics>;
  pieStatisticsMap: GeneralModel.IEntityMap<StatisticsModel.IPieWidgetStatistics>;
  topTenStatisticsMap: GeneralModel.IEntityMap<StatisticsModel.ITopTenStatistics[]>;
  clientDetailStatistics: StatisticsModel.IClientDetailStatistics;
  projectDetailStatistics: StatisticsModel.IProjectDetailStatistics;
  laborCensus: StatisticsModel.ILaborCensus;
  dashboardFilters: StatisticsModel.IDashboardFilter[];
  regionList: GeneralModel.INamedEntity[];
  projects: StatisticsModel.IDashboardProject[];
  workForceMonitoringData: StatisticsModel.IWorkForceMonitoringData;
  dailyLogData: StatisticsModel.IDailyLogData;
}

export const initialState: IState = {
  newBadges: null,
  projectStatistics: null,
  clientStatistics: null,
  inventoryStatistics: null,
  workerStatistics: null,
  grossRevenue: null,
  workersActivity: null,
  grossRevenueWidgetStatistics: null,
  invoiceStatistics: null,
  locationStatistics: null,
  acsProjectStatistics: null,
  bpsProjectStatistics: null,
  projectTopTenStatistics: null,
  clientTopTenStatistics: null,
  clientDetailStatistics: null,
  projectDetailStatistics: null,
  linePieStatisticsMap: {},
  topTenStatisticsMap: {},
  pieStatisticsMap: {},
  laborCensus: null,
  dashboardFilters: [],
  regionList: [],
  projects: [],
  workForceMonitoringData: {
    totalCompanies: 0,
    totalTrades: 0,
    totalWorkers: 0,
  },
  dailyLogData: {
    totalCompanies: 0,
    totalOnSiteHours: 0,
    totalTrades: 0,
    totalWorkers: 0,
    newCompaniesEnrolled: 0,
    newWorkersBadged: 0,
  },
};
